<template>
    <div>
        <HeaderStock header="ตั้งค่าข้อมูลเกี่ยวกับคลัง" :img_header="header_image" link_back="stock" />
        <MenuStockSetting/>
        <StockSourceList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/icon-stock-setting.png'
import HeaderStock from '@/components/menuadmin/stock/stockheader/HeaderStock.vue'
import MenuStockSetting from '@/components/menuadmin/stock/stocksetting/MenuStockSetting.vue'
import StockSourceList from '@/components/menuadmin/stock/stocksetting/StockSourceList.vue'
export default {
    name:'stockSource',
    components:{
        HeaderStock,
        MenuStockSetting,
        StockSourceList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>